export default {
  type: "dark",
  primary: {
    c05: "hsla(245, 18%, 24%, 1)",
    c20: "hsla(245, 18%, 24%, 1)",
    c40: "hsla(248, 26%, 30%, 1)",
    c60: "hsla(247, 35%, 34%, 1)",
    c80: "hsla(247, 35%, 42%, 1)",
    c100: "hsla(247, 40%, 53%, 1)",
    c120: "hsla(247, 56%, 68%, 1)",
    c140: "hsla(248, 100%, 85%, 1)",
    c160: "hsla(249, 100%, 90%, 1)",
    c180: "hsla(252, 100%, 94%, 1)",
  },
  neutral: {
    c00: "hsla(0, 0%, 0%, 1)",
    c20: "hsla(0, 0%, 10%, 1)",
    c30: "hsla(0, 0%, 15%, 1)",
    c40: "hsla(0, 1%, 23%, 1)",
    c50: "hsla(0, 0%, 34%, 1)",
    c60: "hsla(0, 0%, 44%, 1)",
    c70: "hsla(0, 0%, 58%, 1)",
    c80: "hsla(0, 0%, 76%, 1)",
    c90: "hsla(0, 0%, 88%, 1)",
    c100: "hsla(0, 0%, 100%, 1)",
    c100a07: "hsla(0, 0%, 100%, 0.7)",
  },
  success: {
    c05: "hsla(109, 38%, 11%, 1)",
    c10: "hsla(110, 38%, 18%, 1)",
    c20: "hsla(109, 37%, 26%, 1)",
    c40: "hsla(110, 37%, 34%, 1)",
    c60: "hsla(110, 37%, 42%, 1)",
    c80: "hsla(110, 38%, 50%, 1)",
    c100: "hsla(110, 50%, 57%, 1)",
  },
  warning: {
    c05: "hsla(16, 48%, 14%, 1)",
    c10: "hsla(17, 49%, 21%, 1)",
    c20: "hsla(17, 48%, 31%, 1)",
    c40: "hsla(16, 48%, 40%, 1)",
    c60: "hsla(17, 48%, 50%, 1)",
    c80: "hsla(18, 86%, 64%, 1)",
    c100: "hsla(17, 100%, 68%, 1)",
  },
  error: {
    c05: "hsla(0, 50%, 13%, 1)",
    c10: "hsla(359, 51%, 20%, 1)",
    c20: "hsla(358, 51%, 29%, 1)",
    c40: "hsla(359, 51%, 37%, 1)",
    c60: "hsla(359, 51%, 46%, 1)",
    c80: "hsla(359, 62%, 55%, 1)",
    c100: "hsla(359, 84%, 63%, 1)",
  },
};
